module.exports = __webpack_public_path__ + "media/images/area/feature/okinawa/03-d2a8e26f4c83d915fe14bcb443e39930.jpg";